import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as _ from 'lodash';
import { useDraftMenu } from './menus';

const shortcuts = [
  { keys: ['ctrl', 'l'], path: '/report/financial-reports/ledger-report' },
  { keys: ['ctrl', 'b'], path: '/report/financial-reports/balance-sheet-report' },
  { keys: ['ctrl', 'i'], path: '/report/stock-report/item-ledger-report' },
];

const isDraftMenuShortcut = (e) => {
  if (!e.ctrlKey || e.altKey) return false;
  const key = e.key?.toLowerCase();
  return (key === '/' || e.code === 'Slash');
};

export const GlobalKeyDown = () => {
    const navigate = useNavigate();
    const { setShowDraftMenu } = useDraftMenu();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (isDraftMenuShortcut(e)) {
                e.preventDefault();
                setShowDraftMenu((prev) => !prev);
                return;
            }

            const pressedKeys = [];
            if (e.ctrlKey) pressedKeys.push('ctrl');
            if (e.shiftKey) pressedKeys.push('shift');
            if (e.altKey) pressedKeys.push('alt');

            // normalize main key
            const key = e?.key?.toLowerCase();
            if (!['control', 'shift', 'alt'].includes(key)) {
                pressedKeys.push(key);
            }

            // check match
            shortcuts.forEach((shortcut) => {
                const isMatch =
                shortcut.keys.length === pressedKeys.length &&
                shortcut.keys.every((k) => pressedKeys.includes(k));

                if (isMatch) {
                    e.preventDefault(); // avoid browser default
                    navigate(shortcut.path);
                }
            });
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
        window.removeEventListener('keydown', handleKeyDown);
        };
    }, [shortcuts, navigate, setShowDraftMenu]);

    return null;
}
